import React from "react";
import { useSelector } from "react-redux";
import useDateCountdown from "../../utils/useDateCountdown";
import { useNavigate, useParams } from "react-router-dom";
import { CountdownTimer } from "./TimeCounter";
import moment from "moment";
import {
  DefaultPlaceholder,
  EventCardSkeleton,
  EventDetails,
} from "../skeleton/Skeleton";

const format = "ddd, Do MMM YYYY";

const EventDetailsCard = () => {
  const { eventManagement } = useSelector((state) => state);
  const navigate = useNavigate();
  const { eventId } = useParams();

  const event = eventManagement?.selected;

  const { days, hours, minutes, seconds } = useDateCountdown(
    event && event.date && event.date?.slice(0, 10),
    event?.time_start
  );

  return (
    <>
      <div className="container mx-auto  text-white p-6 md:p-12">
        {eventManagement?.isGetEvent ? (
          <div className="flex flex-col lg:flex-row gap-8 w-full">
            <div className="w-full lg:w-[90%]">
              <EventCardSkeleton />
            </div>
            <EventDetails />
          </div>
        ) : (
          <div className="flex flex-col lg:flex-row gap-8 mt-2">
            <div className="w-full lg:w-[45%] md:col-span-2">
              <div className="relative">
                {event?.imageUrl ? (
                  <img
                    src={event?.imageUrl}
                    alt={event._id}
                    className="w-full h-80 object-cover rounded-2xl"
                  />
                ) : (
                  <DefaultPlaceholder />
                )}
              </div>

              <div className="mt-3">
                <span className="dark:text-primary font-semibold text-sm uppercase">
                  {event?.category?.name}
                </span>

                <h2 className="text-3xl md:text-4xl font-bold py-3">
                  {event && event.title}
                </h2>

                <div className="flex flex-col lg:flex-row lg:items-center space-y-4 lg:space-y-0 lg:space-x-4 mt-4">
                  <div className="flex items-center space-x-2">
                    <div className="dark:bg-[#24262a] p-2 rounded-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-primary"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M8 7V3m8 4V3m-6 4h6m4 0h2a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V9a2 2 0 012-2h2m14 0H4m0 0V7m16 0V7"
                        />
                      </svg>
                    </div>
                    <p>
                      {event && event.date
                        ? moment(event.date).format(format)
                        : ""}
                    </p>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="dark:bg-[#24262a] p-2 rounded-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6 text-primary"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 8v4l3 3m6-4a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <p>{`${event?.time_start} - ${event?.time_end}`}</p>
                  </div>
                </div>

                <div className="flex items-center space-x-4 mt-4">
                  <div className="flex items-center space-x-2">
                    <div className="dark:bg-[#24262a] p-2 rounded-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-primary"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 20s6-5.686 6-10a6 6 0 10-12 0c0 4.314 6 10 6 10zM10 11a3 3 0 100-6 3 3 0 000 6z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <p className="capitalize"> {event?.location}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-1">
              <div className="shadow p-4 dark:bg-[#24262a] rounded-md">
                <CountdownTimer
                  days={days}
                  hours={hours}
                  minutes={minutes}
                  seconds={seconds}
                />

                <button
                  className="w-full bg-primary text-white py-3 px-4 rounded  transition duration-300 mt-4 text-center font-semibold text-base"
                  onClick={() => navigate(`/booking/${eventId}`)}
                >
                  <h2 className="text-lg font-semibold"> Get tickets</h2>
                </button>
              </div>

              <div className="mt-6 dark:bg-[#24262a] p-6 rounded-lg shadow-lg">
                <h2 className="text-xl font-semibold">Organizer</h2>
                <div className="flex items-center mt-2">
                  <img
                    src={event?.organizer?.profile}
                    alt=""
                    className="w-14 h-14 object-cover xrounded-full mr-3"
                  />
                  <div>
                    <p className="text-primary mt-2 text-lg">
                      {" "}
                      {event?.organizer?.name}
                    </p>
                    <p className="text-gray-400 -mt-1">
                      {event?.organizer?.email}
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-6 dark:bg-[#24262a] p-6 rounded-lg shadow-lg">
                <h2 className="text-xl font-semibold">About this event</h2>
                <p className="text-gray-400 mt-2">{event?.description}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default EventDetailsCard;
